module.exports = __webpack_public_path__ + "static/media/206-header6.a8e904c3.jpg";